import {createReducer} from '@reduxjs/toolkit';

import {getOrderReviewTotals} from '../../orderReviewTotals/orderReviewTotals';
import {saveCustomerAddresses} from '../customerAddresses/customerAddresses';

export const initialState = '';

/**
 * Error message
 *
 * @return {string} - error state
 */
export const errorMessage = createReducer(initialState, buidler =>
    buidler
        .addCase(saveCustomerAddresses.rejected, (state, action) => {
            return action.payload?.data?.message || 'Something went wrong. Please try again later.';
        })
        .addCase(getOrderReviewTotals.rejected, (state, action) => {
            try {
                const errorResponse = action.payload?.response.data.messages.error[0];
                if (errorResponse?.code === 422) {
                    return 'Invalid ZIP code. Please check and try again.';
                }
                return errorResponse?.message;
            } catch (error) {
                return 'Something went wrong. Please try again later.';
            }
        })
        .addCase(saveCustomerAddresses.pending, () => ''),
);
